import React, { useEffect, useState } from "react";
import { fileUpload } from "../../../fileUpload";
import MediaPicker from "../mediaPicker";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";
import SaveButton from "../AdminButtons";
import { callHowToUseZeroZero } from "../../callApi/home";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
import config from "../../Config.json";

export const HowToUse = () => {
  // fetching admin data from local storage
  const storedData = localStorage.getItem("adminData") || "{}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const dispatch = useDispatch();
  const [option, setOption] = useState(false);

  // state to show data on frontend
  const [data, setData] = useState({
    AdminId: AdminId,
    heading: "",
    stepCards: [],
    ShowInWebSite: "",
    media: {},
  });

  const [arrayIndex, setArrayIndex] = useState(0);

  const _data = data;

  // new card object
  const newCard = {
    id: data.stepCards.length !== 0 ? arrayIndex : 0,
    text: "",
    image: { image: "", file: "", status: "none" },
  };

  //   function to push new cards in the card array
  const handleAdd = () => {
    _data.stepCards.push(newCard);

    setArrayIndex(data.stepCards.length);
    updateData();
  };

  //   function to remove step card from the array
  const handleRemove = (id) => {
    const filteredArray = _data.stepCards.filter((card) => card.id !== id);
    const filteredMedia = _data.media.filter((img) => img.id !== id);
    _data.stepCards = filteredArray;
    _data.media = filteredMedia;
    arrayIndex !== 0 ? setArrayIndex(arrayIndex - 1) : setArrayIndex(0);
    updateData();
  };

  // function to update the state
  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  // function to check if any text field is empty
  const isEmpty = () => {
    let res = false;
    res = data.heading !== "" ? false : true;
    data.stepCards.length !== 0 &&
      data.stepCards.forEach((stepCard) => {
        res = stepCard.text !== "" ? false : true;
      });

    return res;
  };

  const isItEmpty = isEmpty();

  // function to save data
  const handleSave = async () => {
    // dispatch(setLoading(true));

    // array to store all the images
    let media = {};

    if (isItEmpty === false) {
      // array to store updated images
      let updatedCardImages = [];

      {
        data.stepCards.forEach((stepCard) => {
          if (stepCard.image.status === "updated") {
            updatedCardImages.push(stepCard.image);
          }
        });
      }

      if (updatedCardImages.length > 0) {
        const uploadImageRes = await fileUpload(updatedCardImages);

        let tempMedia;
        tempMedia = data?.stepCards?.map((stepCard) => {
          return {
            id: stepCard.id,
            img:
              stepCard.image.status === "updated"
                ? uploadImageRes.find(
                    (x) => x.fileName === stepCard.image.file.name
                  )?.key
                : stepCard.image.status === "none"
                ? data.media[stepCard.id].img
                : null,
            // stepCard.image.status === "none" || "" || null
            // ?
            // : stepCard.image.image,
          };
        });

        media = tempMedia;
        _data.media = tempMedia;
        updateData();
        saveData(media);
      } else {
        media = data.media;
        saveData(media);
      }
    } else {
      toast.error("Please fill all the values");
    }
  };

  // function to call POST request function
  const saveData = (media) => {
    const params = {
      AdminId: data.AdminId,
      media: media,
      heading: data.heading,
      cardTitles: data?.stepCards?.map((stepCard) => stepCard.text),
      ShowInWebSite: data.ShowInWebSite,
    };

    // POSt request
    callHowToUseZeroZero(params)
      .then((res) => {
        dispatch(setLoading(false));
        if (res) {
          toast.success("Data saved successfully");
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        dispatch(setLoading(false));
        toast.error("Error saving data. Please try again!");
        console.error("Error saving data:", error);
      });
  };

  // function to set the ShowInWebSite option
  const handleChange = () => {
    setOption(!option);
    if (option) {
      data.ShowInWebSite = 0;
    } else {
      data.ShowInWebSite = 1;
    }
  };

  // fetch data from local storage
  useEffect(() => {
    dispatch(setLoading(true));
    const howToUseData = JSON.parse(
      sessionStorage.getItem("homeApi")
    ).HowToUseZerozero;

    dispatch(setLoading(false));
    const { ShowInWebSite, content, heading, media } = howToUseData;

    const updatedCards = content.cardText?.map((data, index) => ({
      id: index,
      text: data,
      image: { image: config.awsMediaPath + media[index].img, status: "none" },
    }));

    _data.heading = heading;
    _data.stepCards = updatedCards;
    _data.ShowInWebSite = ShowInWebSite;
    _data.media = media;
    setOption(howToUseData ? howToUseData.ShowInWebSite === 1 : false);
    _data.stepCards.length !== 0
      ? setArrayIndex(data.stepCards.length)
      : setArrayIndex(0);
    updateData();
  }, []);

  return (
    <div className="how-to-use-container">
      <h2 className="main-heading">How to Use Zero zero</h2>
      <div className="input-container">
        <label for="how-to-use-title">Heading</label>
        <input
          id="how-to-use-title"
          type="text"
          className="validate heading-input"
          maxLength={30}
          placeholder="heading"
          onChange={(e) => {
            const { value } = e.target;
            const _data = data;
            _data.heading = value;
            updateData();
          }}
          value={data.heading}
        />
      </div>
      <button className="add-button" onClick={handleAdd}>
        Add Card +
      </button>
      <div className="step-cards-container">
        {data && data.stepCards && data.stepCards.length !== 0
          ? data.stepCards.map(({ id, text, image }, index) => (
              <div className="step-card" key={index}>
                {/* <h2>{id}</h2> */}
                <MediaPicker
                  text="Feature image"
                  type="image"
                  onChange={(file, image) => {
                    _data.stepCards[index].image.image = image;
                    _data.stepCards[index].image.file = file;
                    _data.stepCards[index].image.status = "updated";
                    updateData();
                  }}
                  source={image?.image}
                />
                <textarea
                  id="card-text"
                  type="text"
                  className="validate heading-textarea"
                  // maxLength={100}
                  placeholder="enter text"
                  onChange={(e) => {
                    const { value } = e.target;
                    _data.stepCards[index].text = value;
                    updateData();
                  }}
                  value={text}
                />

                <button
                  className="remove-card-button"
                  onClick={() => handleRemove(id)}
                >
                  Remove
                </button>
              </div>
            ))
          : null}
      </div>
      <div className="input-field">
        <label>
          <span>
            <IsActive
              checked={option}
              // onChange={() => setOption(!option)}
              onChange={handleChange}
            />
          </span>
        </label>
      </div>
      <SaveButton onClick={handleSave} />
    </div>
  );
};
